export const CompanyRuleVI = {
    "companyRule":{
        "title":{
            "header":"Quy định phạt"
        },
        "label":{
            "name":"Lỗi vi phạm",
            "amount":"Số tiền"
        }
    }
}